import styled from 'styled-components';

const StaticPageHolder = styled.div`
	grid-area: content;
	overflow: auto;
	width: 100%;
	a {
		color: #7a7652;
		text-decoration: none;
		touch-action: manipulation;
	}
	h1,
	h2 {
		font-family: "Quicksand", sans-serif;
		font-weight: 700;
		line-height: 1.2;
		margin: 0 0 .5rem 0;
		&.alt {
			background-color: #726b55;
			color: #fdfdfc;
			text-align:left !important;
			width: 100%;
			line-height: 25px;
			height: 50px;
			padding: 12px;
			margin: 0;
			font-size: 24px;
		}
		&.message_success {
			padding: 1rem;
			background: #fff;
			color: #726b55;
		}
		&.message_fail {
			padding: 1rem;
			background: #fff;
			color: #bc1616;
		}
	}
	h2 {
		text-transform: uppercase;
		font-size: 18px;
	}
	.header-back {
		background-color: #383429;
		color: white;
		justify-content: center;
		display: flex;
		padding: 100px;
		h1 {
			font-size: 2.5rem;
			font-weight: 500;
		}
	}
	p {
		font-weight: 500;
		font-size: 17px;
		color: #383838;
		line-height: 1.5em;
		margin: .75em 0;
		a {
			&:link,
			&:visited,
			&:focus,
			&:active {
				color: #a69e87;
			}
			&:hover {
				color: #5f7586;
			}
		}
		&.question {
			font-size: 1.17em;
			font-weight: bold;
			margin: 2rem 0 0 0;
		}
	}
	#content {
		
		article {
			max-width: 720px;
			margin: 80px auto;
			display: block;
		}
		h2 {
			margin-top: 40px;
			text-transform: uppercase;
    		font-size: 18px;
			font-family: "Quicksand", sans-serif;
		}
		
	}
	section {
		display:block;
	}
	
	h4 {
		color: #7a7652;
	}
	img {
		left: 0;
		margin-top: 0px;
	}
	.section {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}
	.faq-styles {
		text-align: center;
		margin-top: 50px;
		font-size: 18px;
		font-family: "Quicksand", sans-serif;
		font-weight: 600;
	}
	ol,
	ul {
		margin: 0 0 1rem 0;
		.sub-list {
			padding-inline-start: 20px;
		}
	}
	ul {
		&.reg-list {
			list-style-type: none;
		}
		li {
			font-weight: 700;
			&::before {
				content: "■";
				color: #858585;
				font-size: 1.25em;
				margin-left: -.8em;
				margin-right: .5em;
				line-height: 1.875;
				position: relative;
				top: .1em;
			}
		}
		&.normal-list {
			list-style-type: disc;
		}
		li.normal {
			font-weight: 400;
			line-height: 1.5;
			margin-bottom: 1rem;
			&::before {
				content: '';
				margin-left: 0;
				margin-right: 0;
				font-size: 1.25em;
				line-height: 1;
			}
		}
	} 
	a {
		&:link,
		&:visited,
		&:hover,
		&:focus,
		&:active {
			color: #726b55;
			text-decoration: none;
		}
	}
	.grid-flex {
		display:flex;
		flex-flow: row wrap;
	}
	@media (min-width: 48em) {
		.flex-item.-mid-50,
		.grid-flex > .-mid-50 {
			width: calc(50% - 2rem);
			max-width: calc(50% - 2rem);
			flex: 1 1 auto;
		}
	}
	.flex-item.-toppad,
	.grid-flex > .-toppad {
		padding-top: 0;
		padding-left: 0;
		padding-right: 0;
	}
	.flex-item,
	.grid-flex > * {
		display: flex;
		float: none;
		clear: none;
		flex-flow: column nowrap;
		width: calc(100% - 1.2rem);
		flex: 1 0 auto;
		margin: 1.2rem 1rem 0;
		padding: 1.2rem 1.2rem 0;
	}
	.form_wrapper {
		padding-left: 1rem;
		padding-right: 1rem;
		max-width: 720px;
    	margin: 0 auto;
		.btn--primary {
			width: calc(100% - 2em);
			background: #726b55;
			border: solid 5px #d1cdc1 !important;
			color:#fdfdfc;
			position: relative;
			z-index: 10;
			margin: 1rem auto calc(1rem + 5px) auto;
			min-width: 20rem;
			text-transform: uppercase;
			transition: all 0.2s ease-in;
			font-size: 12px;
			font-size: 1.2rem;
			line-height: 1.25;
			display: inline-block;
			cursor: pointer;
			text-align: center;
			text-decoration: none;
			letter-spacing: .025em;
			border: 0 solid transparent;
			border-radius: 2em;
			padding: .75rem .75rem;
			&:before {
				background-color: rgba(122,118,82,.4);
				content: '';
				transition: background-color .3s ease-out;
				position: absolute;
				top: -5px;
				right: -5px;
				bottom: -5px;
				left: -5px;
				z-index: -1;
				width: calc(100% + 10px);
				height: calc(100% + 10px);
				border-radius: 2em;
			}
			&:after {
				content: '';
				transition: background-color .3s ease-out;
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 2em;
				z-index: -2;
			}
			&:hover {
				background: #a69e87 !important;
				border: solid 5px #a69e87 !important;
				transition: all 0.2s ease-in;
			}
			&:disabled {
				background-color: #a9b2b1;
				border: 5px solid #f1f3f3 !important;
				cursor: default;
				&:before {
					background-color: rgba(169,178,177,.2 ) !important;
				}
				&:hover {
					background-color: #a9b2b1 !important;
					border: solid 5px #a9b2b1 !important;
				}
			}
			&:focus {
				outline: 2px solid #a9b2b1;
				box-shadow: 1px 1px 4px 1px #726b55;
			}
		}
	}	
	.field_label {
		font-size: 12px;
		font-size: 1.2rem;
		display: block;
		font-weight: 700;
		padding-bottom: 0;
		color: #34383b;
		margin-bottom: .8rem;
		span{
			font-weight: normal;
		}
	}
	input,
	select,
	textarea {
		font-size: 11px;
		font-size: 1rem;
		font-weight: 400;
		width: 100%;
		margin-bottom: 1rem;
		padding: .8rem;
		color: #606060;
		border: 1px solid #a9b2b1;
		border-radius: 5px;
		outline: 0;
		background-color: #FFF;
		&:focus {
			outline: 2px solid #a9b2b1;
			box-shadow: 1px 1px 4px 1px #a9b2b1;
		}
	}
	label {
		font-family: "Quicksand", sans-serif;
		font-size: 20px;
		font-weight: 400;
		line-height: 1.5em;
		color: #34383b;
		margin: 40px 0 8px 0;
	}
	.input_container_checkbox {
		display: flex;
		align-items: flex-start;
		flex-flow: row wrap;
		justify-content: flex-start;
	}
	.checkbox,
	.radio {
		max-width: 2rem;
		height: 1.2rem;
	}
	.checkbox {
		&:not(old) {
			width: 28px;
			margin: 0;
			padding: 0;
			opacity: 0;
			& + label {
				display: inline-block;
				line-height: 1.5em;
				font-weight: 400;
			}
		}
		&:checked {
			& + label {
				&::after {
					content: '✔︎';
    				color: white;
				}
			}
		}
		& + label {
			cursor: pointer;
			display: inline-block;
			position: relative;
			padding: .5rem;
			margin-right: 1rem;
			&::before {
				content: " ";
				display: inline-block;
				width: 1.5em;
				height: 1.5em;
				margin: 0.5em .5em 0 0.25em;
				border: 1px solid rgba(133, 133, 133, 0);
				border-radius: 0.25em;
				background: #d1cdc1;
				vertical-align: bottom;
				transition: all 0.2s ease-in;
			}
			&::after {
				content: '✔︎';
				font-family: "Open Sans", sans-serif;
				display: block;
				width: 1.5em;
				color: rgba(255, 255, 255, 0);
				font-size: 1em;
				line-height: 0;
				position: relative;
				text-align: center;
				top: -.75em;
				left: .3em;
				margin: 0;
			}
		}
	}

	.radio {
		&:checked {
			& + label {
				&::before {
					border: 8px solid #5f7586;
    				background-color: #d2d9df;
					width: 1em;
					height: 1em;
				}
			}
		}
		&:not(old) {
			width: 28px;
			margin: 0;
			padding: 0;
			opacity: 0;
			& + label {
				display: inline-block;
				line-height: 1.5em;
				font-weight: 400;
			}
		}
		& + label {
			&::before {
				border-radius: 1.25em;
				content: " ";
				display: inline-block;
				width: 1.5em;
				height: 1.5em;
				margin: 0.5em .5em 0 0.25em;
				border: 1px solid rgba(133, 133, 133, 0);
				background: #d1cdc1;
				vertical-align: bottom;
				transition: all 0.2s ease-in;
			}
		}
	}
	.sp_field_description {
		margin-bottom: 1rem;
		&.invalid {
			color:red;
		}
	}
	#content {
		position: relative;
		margin: 0 auto;
		clear: both;
		right: 0;
		max-width: 1920px;
		@media (max-width: 767px) {
			padding: 0 10px;
		}
	}
	.center-page {
        @media screen and (max-width: 475px) {
            margin-left: 12px !important;
            margin-right: 12px;
        }
        .row {
            clear: both;
            display: flex;
            justify-content: space-around;
            flex-flow: row;
            align-items: stretch;
            .margin-top-huge {
                margin-top: 20px !important;
            }
            &.margin-bottom-xhuge {
                margin-bottom: 40px !important;
            }
            @media screen and (max-width: 767px) {
                flex-wrap: wrap;
            }
        }
        p {
            max-width: 33em;
            min-width: 10em;
            margin: .75em 0;
            display: inline-block;
            font-weight: 500;
            font-size: 17px;
            color: #383838;
            line-height: 1.5em;
            @media screen and (max-width: 767px) {
                font-size: 14px !important;
                min-width: 10em !important;
                display: block !important;
            }
        }
        .small-print {
            font-size: 12px !important;
        }
        .margin-bottom-huge {
            margin-bottom: 20px !important;
		}
    }
	.row {
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-flow: row;
		align-items: stretch;
		
	}
	.module {
		position: relative;
		width: 100%;
		background-color: transparent;
		transition: all 0.4s ease-in;
		display: block;
	}
	.row_wrap {
		margin: 0 auto;
		flex-wrap: wrap;
		.module {
			margin-left: 8px;
			margin-right: 8px;
			max-width: 31% !important;
			position:relative;
			&.module_pod {
				background-color: white;
				padding: 20px 30px;
				box-shadow: 0 0 10px rgb(0 0 0 / 10%);
				margin: 20px 8px;
				max-width: 576px;
				.podcast-title {
					text-align: center;
					margin: 0 0 1em 0;
    				color: #35414b;
					clear: both;
					font-family: "Quicksand", sans-serif;
					font-size: 1.75rem;
					font-weight: 500;
					line-height: 1.2;
					@media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: portrait) {
						font-size: 1.3rem;
					}
				}
				.author-pod {
					display: block;
    				margin-bottom: 20px;
					img {
						display: block;
						align-content: center;
						margin: 0 auto;
						border-radius: 100%;
						max-width: 100%;
					}
				}
				.source-pod {
					text-align: center;
					clear: both;
					.alt {
						font-size: 17px;
						color: #5f7586;
						text-transform: uppercase;
						clear: both;
						font-family: "Quicksand", sans-serif;
						margin-bottom: 0.5rem;
						font-weight: 500;
    					line-height: 1.2;
					}
					a {
						touch-action: manipulation;
						img {
							max-width: 100%;
							vertical-align: middle;
    						border-style: none;
							opacity: .8;
							transform: scale(0.9);
							&:hover {
								opacity: 1;
								transform: scale(1);
							}
							@media screen and (max-width: 600px) {
								clear: both;
								display: block;
								margin: 0 auto;
							}
						}
					}
				}
				@media screen and (max-width: 475px) {
					margin-left: 0px;
					margin-right: 0px;
					max-width: 100% !important;
					padding: 20px 20px;
				}
			}			
			& > .module_article {
				overflow-wrap: break-word;
				position: relative;
				margin: 0 auto !important;
				p {
					max-width: 33em;
					min-width: 10em;
					margin: .75em 0;
					display: inline-block;
					@media screen and (max-width: 767px) {
						font-size: 14px;
						min-width: 10em;
						display: block;
					}
				}
			}
		}
	}
	.share-container {
		text-align: center;
		margin: 2rem ;
	}
	.shortcuts-table {
		max-width: 720px;
    	margin: 1rem auto;
		table {
			border-collapse: collapse; 
			width: 100%; 
			border-color: #95a5a6; 
			border-style: solid; 
			float: left;
			td.left-col {
				width: 26%;
			}
			td.right-col {
				width: 71%;
			}
		}
	}
	p {
		&.text{
			max-width: 720px;
			margin: 1rem auto;
		}
		&.hidden {
			margin: 0;
			height: 0;
		}
		
	}
	.radioCheck label{
		margin: 0 0 8px 0;
		padding: 0 8px 8px; 
	}
	input[type="radio"]:focus + label:before, input[type="checkbox"]:focus + label:before {
		outline: 2px solid #a9b2b1;
		box-shadow: 1px 1px 4px 1px #a9b2b1;
	}
	ol.cyvl_list li::marker, ol.cyvl_list li ol li::marker {
		font-weight: 700;
	}
	ol.cyvl_list, ol.terms li {
		margin: 0.75em 0;
		li ol li {
			margin-top: .5em;
		}
	}
	ol.terms li {
		h2 {
			text-decoration: underline;
			font-weight: 700;
		}
		&::marker {
			font-weight: 700;
		}
		p.uppercase {
			text-transform: uppercase;
		}
	}
	ol.privacy_policy {
		padding-left: 1rem;
		li::marker {
			font-weight:bold;
		}
	}
	.recaptcha {
		margin: 1.5rem 0;
	}
	.form_footer {
		text-align: center;
	}
	.bottom_content article {
		margin: 40px auto !important;
	}
`;

export default StaticPageHolder;